import {findMaxE} from "@Common/utils/collections";

export const getContainRatio = (outSize, inSize) => {
    const restrictedDimension = findMaxE(
        [
            "width", "height"
        ],
        (d) => {
            const other = (d) => d === "width" ? "height" : "width";
            return inSize[d] / inSize[other(d)] / (outSize[d] / outSize[other(d)]);
        },
    );
    return outSize[restrictedDimension] / inSize[restrictedDimension];
};
